const ru = {
  lang: 'ru',
  langLabel: 'RU',
  langName: 'Русский',

  common: {
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Изменить',
    add: 'Добавить',
    back: 'Назад',
    search: 'Поиск',
    loading: 'Загрузка…',
    submitting: 'Отправка…',
    saving: 'Сохранение…',
    confirm: 'Подтвердить',
    close: 'Закрыть',
    yes: 'Да',
    no: 'Нет',
    actions: 'Действия',
    status: 'Статус',
    name: 'Имя',
    email: 'Email',
    phone: 'Телефон',
    address: 'Адрес',
    date: 'Дата',
    notes: 'Примечания',
    description: 'Описание',
    total: 'Итого',
    active: 'Активный',
    inactive: 'Неактивный',
    all: 'Все',
    export: 'Экспорт',
    import: 'Импорт',
    create: 'Создать',
    update: 'Обновить',
    refresh: 'Обновить',
    logout: 'Выйти',
    noData: 'Данные не найдены',
    error: 'Произошла ошибка',
    success: 'Успешно',
    required: 'обязательно',
    optional: 'необязательно',
    notAssigned: 'Не назначен',
    noneSelected: '-- Выберите --',
    history: 'История',
    view: 'Просмотр',
    details: 'Детали',
    areYouSure: 'Вы уверены?',
    cannotUndo: 'Это действие нельзя отменить.',
    currency: 'UZS',
    month: 'Месяц',
    year: 'Год',
  },

  status: {
    ACTIVE: 'Активный',
    INACTIVE: 'Неактивный',
    PENDING: 'Ожидает',
    PAID: 'Оплачено',
    OVERDUE: 'Просрочено',
    CANCELLED: 'Отменено',
    COMPLETED: 'Завершено',
    SCHEDULED: 'Запланировано',
    APPROVED: 'Одобрено',
    REJECTED: 'Отклонено',
    ON_LEAVE: 'В отпуске',
    SUSPENDED: 'Приостановлен',
    TERMINATED: 'Уволен',
    RESIGNED: 'Уволился',
    PRESENT: 'Присутствует',
    ABSENT: 'Отсутствует',
    LATE: 'Опоздал',
    EXCUSED: 'Уважительная причина',
  },

  nav: {
    dashboard: 'Панель управления',
    students: 'Студенты',
    teachers: 'Преподаватели',
    groups: 'Группы',
    payments: 'Платежи',
    expenditures: 'Расходы',
    exams: 'Экзамены и оценки',
    certificates: 'Сертификаты',
    attendance: 'Посещаемость',
    homework: 'Домашние задания',
    comments: 'Комментарии',
    telegram: 'Telegram',
    staff: 'Персонал',
    messages: 'Сообщения',
    reports: 'Отчёты',
    centers: 'Центры',
    teacherSalaries: 'Зарплаты учителей',
    printMaterials: 'Печатные материалы',
    logout: 'Выйти',
    atRisk: 'Группа риска',
    marketIntel: 'Аналитика рынка',
    competitors: 'Конкуренты',
    marketReport: 'Отчёт по рынку',
  },

  auth: {
    selectSchool: 'Выберите школу',
    selectSchoolSub: 'Выберите ваш языковой центр для продолжения',
    noSchool: 'Не видите свою школу?',
    registerSchool: 'Зарегистрировать школу →',
    platformAdmin: 'Вход для администратора платформы',
    loginTitle: 'Добро пожаловать',
    loginSub: 'Войдите в свой аккаунт',
    email: 'Email',
    password: 'Пароль',
    signIn: 'Войти',
    forgotPassword: 'Забыли пароль?',
    noAccount: 'Нет аккаунта?',
    signUp: 'Зарегистрироваться',
    backToLogin: '← Назад к входу',
    changeCenter: 'Изменить',
    registerTitle: 'Зарегистрировать школу',
    registerSub: 'Настройте свой аккаунт School CRM за несколько минут',
    newSchool: 'Новая школа',
    joinExisting: 'Вступить в существующую',
    firstName: 'Имя',
    lastName: 'Фамилия',
    centerName: 'Название школы',
    centerCode: 'Код школы',
    centerAddress: 'Адрес',
    brandColor: 'Фирменный цвет',
    confirmPassword: 'Подтвердите пароль',
    passwordMismatch: 'Пароли не совпадают',
    passwordTooShort: 'Пароль должен содержать не менее 6 символов',
    createAccount: 'Создать аккаунт',
    verifyTitle: 'Проверьте почту',
    verifyCode: 'Введите 6-значный код, отправленный на',
    resend: 'Отправить повторно',
    verify: 'Подтвердить',
    forgotTitle: 'Забыли пароль?',
    forgotSub: 'Не беспокойтесь, мы отправим вам 6-значный код для сброса.',
    sendCode: 'Отправить код',
    resetTitle: 'Введите код сброса',
    resetSub: 'Мы отправили код сброса на',
    newPasswordTitle: 'Установите новый пароль',
    newPasswordSub: 'Выберите надёжный пароль для своего аккаунта.',
    newPassword: 'Новый пароль',
    setPassword: 'Установить пароль',
    doneTitle: 'Пароль сброшен!',
    doneSub: 'Ваш пароль успешно обновлён. Теперь вы можете войти с новым паролем.',
    signInNow: 'Войти',
    platformTitle: 'Администратор платформы',
    platformSub: 'Ограниченный доступ — только для авторизованных лиц',
    signInPlatform: 'Войти как администратор платформы',
    wrongRole: 'Этот вход только для администраторов платформы',
    strengthWeak: 'Слабый',
    strengthFair: 'Средний',
    strengthStrong: 'Сильный',
    resendIn: 'Повторно через',
    seconds: 'с',
    codeExpired: 'Код истёк?',
    backToSignup: '← Назад к регистрации',
  },

  dashboard: {
    title: '📊 Панель управления',
    activeStudents: 'Активные студенты',
    teachers: 'Преподаватели',
    groups: 'Группы',
    studentsPaid: 'Оплатили',
    studentsPending: 'Ожидают оплаты',
    studentsOverdue: 'Просрочили оплату',
    present: 'Присутствуют',
    absent: 'Отсутствуют',
    late: 'Опоздали',
    paymentStatus: '💰 Статус оплаты',
    attendanceMonth: '📝 Посещаемость сегодня',
    alerts: '🚨 Уведомления',
    quickActions: 'Быстрые действия',
    systemStatus: 'Состояние системы',
    paidThisMonth: 'оплатили в этом месяце',
    awaitingPayment: 'ожидают оплаты',
    overdueMonth: 'просрочили в этом месяце',
    totalInDB: 'всего в базе',
    activeInstructors: 'Активных преподавателей',
    allActiveGroups: 'Все активные группы',
    records: 'записей',
    addStudent: '➕ Добавить студента',
    addTeacher: '➕ Добавить преподавателя',
    createGroup: '➕ Создать группу',
    dismissAll: 'Скрыть все',
    loadingAlerts: 'Загрузка уведомлений…',
    activeOf: 'активных из',
    activeGroups: 'активных групп',
    paid: 'оплатили',
    unpaid: 'не оплатили',
  },

  students: {
    title: '👥 Студенты',
    addStudent: '➕ Добавить студента',
    deleteAll: '🗑️ Удалить всех',
    exportCsv: '📥 Экспорт CSV',
    importStudents: '📤 Импорт студентов',
    searchPlaceholder: 'Поиск по имени или ID студента…',
    totalStudents: 'Всего студентов',
    showing: 'Показано',
    results: 'результатов',
    noStudents: 'Студенты не найдены по вашему запросу',
    noStudentsYet: 'Студентов пока нет. Импортируйте студентов для начала.',
    failedLoad: '❌ Не удалось загрузить студентов',
    deleted: '✅ Студент успешно удалён',
    failedDelete: '❌ Не удалось удалить студента',
    errorDelete: '❌ Ошибка при удалении студента',
    confirmDelete: 'Вы уверены, что хотите удалить этого студента?',
    confirmDeleteAll: '⚠️ ВНИМАНИЕ: Это удалит ВСЕХ студентов и родителей. Вы абсолютно уверены?',
    typeToConfirm: 'Введите "DELETE ALL" для подтверждения.',
    studentId: 'ID студента',
    groups: 'Группы',
    groupCount: 'группы',
  },

  teachers: {
    title: '👨‍🏫 Управление преподавателями',
    subtitle: 'Управление всеми преподавателями и их назначениями',
    addTeacher: '➕ Добавить преподавателя',
    searchPlaceholder: '🔍 Поиск преподавателей…',
    noTeachers: 'Преподаватели не найдены',
    tryAdjusting: 'Попробуйте изменить параметры поиска',
    confirmDelete: 'Вы уверены, что хотите удалить этого преподавателя?',
    specialization: '🎯 Специализация',
    editTeacher: '✏️ Изменить преподавателя',
    firstName: 'Имя',
    lastName: 'Фамилия',
    password: 'Пароль',
    updateTeacher: 'Обновить преподавателя',
  },

  groups: {
    title: '📚 Группы',
    addGroup: '➕ Добавить группу',
    editGroup: 'Изменить группу',
    addNewGroup: 'Добавить новую группу',
    searchPlaceholder: 'Поиск по названию или коду группы…',
    totalGroups: 'Всего групп',
    groupName: 'Название группы',
    groupCode: 'Код группы',
    level: 'Уровень',
    maxStudents: 'Макс. студентов',
    teacher: 'Преподаватель',
    schedule: 'Расписание',
    noTeacher: '-- Без преподавателя --',
    createGroup: 'Создать группу',
    updateGroup: 'Обновить группу',
    manageStudents: '👥 Управление студентами',
    enrolled: 'Зачислены',
    available: 'Доступны',
    searchEnrolled: 'Поиск среди зачисленных…',
    searchAvailable: 'Поиск среди доступных…',
    remove: 'Удалить',
    noStudentsEnrolled: 'Студентов ещё нет',
    allEnrolled: 'Все студенты зачислены',
    noHistory: 'История не найдена.',
    historyNote: 'Полная история зачисления в группу — все студенты, которые были добавлены или удалены.',
    added: 'Добавлен',
    removed: 'Удалён',
    students: 'Студенты',
    sessions: 'Занятия',
    noGroups: 'Группы не найдены',
    confirmDeleteGroup: 'Вы уверены, что хотите удалить эту группу?',
    confirmRemoveStudent: 'Удалить этого студента из группы?',
    levels: {
      A1: 'A1 - Начинающий',
      A2: 'A2 - Элементарный',
      B1: 'B1 - Средний',
      B2: 'B2 - Выше среднего',
      C1: 'C1 - Продвинутый',
      C2: 'C2 - Мастерство',
    },
  },

  attendance: {
    title: '📊 Статистика посещаемости',
    subtitle: 'Все группы · статистика посещаемости',
    totalSessions: 'Всего занятий',
    overallRate: 'Общий показатель',
    searchPlaceholder: 'Поиск по названию группы, коду или преподавателю…',
    sortBy: 'Сортировка:',
    byName: 'По имени',
    byRate: 'По показателю',
    bySessions: 'По занятиям',
    byStudents: 'По студентам',
    noSessions: 'Нет занятий',
    noGroups: 'Группы не найдены.',
    viewAbsent: '🔴 Смотреть отсутствующих',
    absentStudents: '🔴 Отсутствующие студенты',
    addComment: 'Добавить комментарий для этого студента…',
    noAbsent: 'Нет отсутствующих студентов.',
    loadingSessions: 'Загрузка занятий…',
    noSessionsRecorded: 'Занятия ещё не записаны.',
    rate: 'Показатель',
    lastSession: 'Последнее занятие',
    attendanceRate: 'Посещаемость',
    markAttendance: 'Отметить посещаемость',
    present: 'Присутствует',
    absent: 'Отсутствует',
    late: 'Опоздал',
    excused: 'Уважительная причина',
    submit: 'Сохранить посещаемость',
  },

  payments: {
    title: '💰 Управление платежами',
    addPayment: 'Добавить платёж',
    amount: 'Сумма',
    method: 'Способ оплаты',
    dueDate: 'Дата оплаты',
    paidAt: 'Оплачено',
    invoiceNumber: 'Счёт №',
    methods: {
      CASH: 'Наличные',
      CARD: 'Карта',
      TRANSFER: 'Перевод',
      ONLINE: 'Онлайн',
    },
    statuses: {
      PAID: 'Оплачено',
      PENDING: 'Ожидает',
      OVERDUE: 'Просрочено',
      CANCELLED: 'Отменено',
    },
    markPaid: 'Отметить как оплаченное',
    passcodeRequired: 'Требуется код доступа',
    incorrectPasscode: 'Неверный код доступа',
    monthlyRevenue: 'Доход за месяц',
    collected: 'Собрано',
    expected: 'Ожидается',
  },

  expenditures: {
    title: '📉 Расходы',
    addExpenditure: 'Добавить расход',
    category: 'Категория',
    categories: {
      ALL: 'Все',
      RENT: 'Аренда',
      UTILITIES: 'Коммунальные',
      SALARIES: 'Зарплаты',
      SUPPLIES: 'Расходные материалы',
      EQUIPMENT: 'Оборудование',
      MARKETING: 'Маркетинг',
      MAINTENANCE: 'Обслуживание',
      CLEANERS: 'Уборщики',
      OTHER: 'Прочее',
    },
    confirmDelete: 'Удалить этот расход?',
    title_field: 'Название',
    totalSpent: 'Всего потрачено',
    dailyTotal: 'Итого за день',
  },

  exams: {
    title: '📋 Экзамены и оценки',
    addExam: 'Добавить экзамен',
    examTitle: 'Название экзамена',
    subject: 'Предмет',
    type: 'Тип',
    group: 'Группа',
    maxScore: 'Макс. балл',
    passingScore: 'Проходной балл',
    gradeEntry: 'Ввод оценок',
    saveGrades: 'Сохранить оценки',
    gradesSaved: 'Оценки сохранены!',
    avgScore: 'Средний балл',
    passRate: 'Процент сдачи',
    confirmDelete: 'Удалить этот экзамен и все его результаты?',
    types: {
      WRITTEN: 'Письменный',
      ORAL: 'Устный',
      PRACTICAL: 'Практический',
      ONLINE: 'Онлайн',
      QUIZ: 'Тест',
    },
    statuses: {
      SCHEDULED: 'Запланирован',
      COMPLETED: 'Завершён',
      CANCELLED: 'Отменён',
    },
    score: 'Балл',
    absent: 'Отсутствовал',
    participant: 'Участников',
  },

  comments: {
    title: '💬 Обратная связь',
    addFeedback: 'Добавить отзыв',
    selectGroup: 'Выберите группу',
    selectStudent: 'Выберите студента',
    quickComments: 'Быстрые комментарии',
    commentPlaceholder: 'Напишите отзыв о студенте…',
    addComment: '💬 Добавить комментарий',
    recentFeedback: 'Последние отзывы',
    noComments: 'Нет последних комментариев',
    by: 'От',
    failedLoad: '❌ Не удалось загрузить',
    added: '✅ Комментарий успешно добавлен!',
    failedAdd: '❌ Не удалось добавить комментарий',
  },

  homework: {
    title: '📓 Домашние задания',
    addHomework: 'Добавить задание',
    dueDate: 'Срок сдачи',
    points: 'Баллы',
    type: 'Тип',
    submissions: 'Ответы',
    results: 'Результаты',
    confirmDelete: 'Вы уверены, что хотите удалить это задание?',
    noHomework: 'Заданий не найдено',
    titleRequired: '❌ Требуются название и срок сдачи',
    created: '✅ Задание успешно создано!',
    deleted: '✅ Задание удалено',
  },

  staff: {
    title: '👔 Управление персоналом',
    addStaff: 'Добавить сотрудника',
    employeeId: 'ID сотрудника',
    position: 'Должность',
    department: 'Отдел',
    employmentType: 'Тип занятости',
    hireDate: 'Дата найма',
    baseSalary: 'Базовая зарплата',
    paymentFrequency: 'Периодичность выплат',
    emergencyContact: 'Контакт для экстренной связи',
    types: {
      FULL_TIME: 'Полная занятость',
      PART_TIME: 'Частичная занятость',
      CONTRACT: 'Договор',
    },
  },

  messages: {
    title: '📨 Сообщения',
    typeMessage: 'Введите сообщение…',
    send: 'Отправить',
    teachers: 'Преподаватели',
    students: 'Студенты',
    parents: 'Родители',
    admin: 'Администратор',
    noConversation: 'Выберите чат для начала общения',
  },

  teacherPortal: {
    title: '🎓 Портал преподавателя',
    home: '🏠 Главная',
    myGroups: '📚 Мои группы',
    attendance: '📝 Посещаемость',
    homework: '📓 Задания',
    exams: '📋 Экзамены и оценки',
    comments: '💬 Комментарии',
    logout: '🚪 Выйти',
    welcome: 'Добро пожаловать',
    todayOverview: 'Ваш обзор на сегодня.',
    myGroupsLabel: 'Мои группы',
    totalStudents: 'Всего студентов',
    today: 'Сегодня',
    noGroups: 'Группы пока не назначены.',
    attendanceBtn: 'Посещаемость',
    gradesBtn: 'Оценки',
    submitAttendance: 'Сохранить посещаемость',
    saving: 'Сохранение…',
    commentAdded: '✅ Комментарий успешно добавлен',
    addComment: 'Добавить комментарий',
    selectStudent: 'Выберите студента',
    commentText: 'Комментарий',
    commentPlaceholder: 'Напишите ваш комментарий…',
  },

  parentPortal: {
    title: '👨‍👩‍👧 Портал родителя',
    myChild: 'Мой ребёнок',
    attendance: 'Посещаемость',
    payments: 'Платежи',
    comments: 'Комментарии',
    groups: 'Мои группы',
    attendanceCalendar: 'Календарь посещаемости',
    present: 'Присутствует',
    absent: 'Отсутствует',
    late: 'Опоздал',
    excused: 'Уважительная',
    noData: 'Нет данных за этот период',
    recentPayments: 'Последние платежи',
    recentComments: 'Последние комментарии',
    noPayments: 'Нет записей о платежах',
    noComments: 'Комментариев пока нет',
    level: 'Уровень',
    teacher: 'Преподаватель',
    schedule: 'Расписание',
    days: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
  },

  master: {
    title: 'Главная панель управления',
    subtitle: 'Мониторинг и управление всеми школами на платформе',
    totalSchools: 'Всего школ',
    totalStudents: 'Всего студентов',
    totalTeachers: 'Всего преподавателей',
    monthlyRevenue: 'Доход за месяц',
    searchPlaceholder: 'Поиск школ по названию или коду…',
    viewDetails: 'Подробнее',
    disable: 'Отключить',
    enable: 'Включить',
    resetPw: 'Сброс пароля',
    resetPassword: 'Сбросить пароль',
    newPassword: 'Новый пароль (мин. 6 символов)',
    lastActivity: 'Последняя активность',
    avgExamScore: 'Средний балл экзамена',
    never: 'Никогда',
    backToSchools: '← Назад ко всем школам',
    monthlyRevenueLabel: 'Доход за месяц',
    newStudents: 'Новые студенты',
    recentExams: 'Последние экзамены',
    paidThisMonth: 'Оплачено (этот месяц)',
    pending: 'Ожидает',
    overdue: 'Просрочено',
    signOut: 'Выйти',
    platformLabel: 'МАСТЕР',
    revenue: 'Доход',
    thisMonth: 'в этом месяце',
    loadingPlatform: 'Загрузка данных…',
    failedLoad: 'Не удалось загрузить данные',
    examCol: 'Экзамен',
    groupCol: 'Группа',
    dateCol: 'Дата',
    avgScoreCol: 'Средний балл',
    passRateCol: 'Успеваемость',
    studentsCol: 'Студенты',
  },

  centers: {
    title: '🏢 Языковые центры',
    subtitle: 'Управляйте центрами вашей организации. У каждого центра свой вход.',
    addCenter: '+ Добавить центр',
    newCenter: 'Новый центр',
    editCenter: 'Изменить центр',
    centerName: 'Название центра',
    code: 'Код',
    codeHint: '(уникальный slug, без пробелов)',
    logoUrl: 'URL логотипа',
    logoOptional: '(необязательно)',
    brandColor: 'Фирменный цвет',
    preview: 'Предпросмотр',
    created: '✅ Центр создан',
    updated: '✅ Центр обновлён',
  },
  certificates: {
    title: 'Сертификаты',
    addCertificate: 'Добавить сертификат',
    editCertificate: 'Редактировать сертификат',
    student: 'Студент',
    teacher: 'Преподаватель',
    type: 'Тип',
    examDate: 'Дата экзамена',
    issueDate: 'Дата выдачи',
    result: 'Результат',
    notes: 'Заметки',
    typeIELTS: 'IELTS',
    typeCEFR: 'CEFR',
    typeCUSTOM: 'Другой',
    ieltsOverall: 'Общий балл',
    ieltsListening: 'Listening',
    ieltsReading: 'Reading',
    ieltsWriting: 'Writing',
    ieltsSpeaking: 'Speaking',
    cefrLevel: 'Уровень CEFR',
    customName: 'Название сертификата',
    customResult: 'Результат / Балл',
    statistics: 'Статистика',
    totalCertificates: 'Всего сертификатов',
    byTeacher: 'По преподавателям',
    avgBand: 'Средний балл IELTS',
    ieltsDistribution: 'Распределение баллов IELTS',
    cefrDistribution: 'Распределение уровней CEFR',
    monthlyTrend: 'Тенденция по месяцам',
    exportExcel: 'Экспорт в Excel',
    annual: 'Годовой',
    monthly: 'Месячный',
    noCertificates: 'Сертификатов не найдено',
    confirmDelete: 'Вы уверены, что хотите удалить этот сертификат?',
    saved: 'Сертификат успешно сохранён',
    deleted: 'Сертификат удалён',
    list: 'Сертификаты',
    certificateFile: 'Файл сертификата',
    viewFile: 'Просмотр',
    uploadFile: 'Загрузить PDF или изображение (макс 10 МБ)',
  },

  aiAssistant: {
    title: 'AI Ассистент',
    placeholder: 'Спросите об учениках, платежах, посещаемости...',
    send: 'Отправить',
    close: 'Закрыть',
    error: 'Что-то пошло не так. Попробуйте ещё раз.',
    thinking: 'Думаю...',
    welcome: 'Привет! Я могу помочь с вопросами о данных вашей школы. Попробуйте спросить:',
    suggestion1: 'Кто не оплатил в этом месяце?',
    suggestion2: 'Какие ученики часто отсутствуют?',
    suggestion3: 'Покажи выручку за этот месяц',
    suggestion4: 'Какие группы сейчас активны?',
    suggestion5: 'Покажи общую статистику школы',
  },

  market: {
    title: 'Аналитика рынка',
    competitors: 'Конкуренты',
    marketReport: 'Отчёт по рынку',
    threatLevel: 'Уровень угрозы',
    bcPartner: 'Партнёр BC',
    high: 'Высокий',
    medium: 'Средний',
    low: 'Низкий',
    addCompetitor: 'Добавить конкурента',
    editCompetitor: 'Редактировать',
    deactivate: 'Деактивировать',
    history: 'История',
    noHistory: 'История отсутствует.',
    consideredBy: 'Рассматривали',
    studentsLost: 'Потерянные ученики',
    lastChecked: 'Последняя проверка',
    source: 'Как нашли',
    whyChoseUs: 'Почему выбрали нас',
    homeDistrict: 'Район проживания',
    leavingReason: 'Причина ухода',
    wentToCompetitor: 'Ушёл к конкуренту',
    whichCompetitor: 'К какому конкуренту?',
    sourceTelegram: 'Telegram',
    sourceInstagram: 'Instagram',
    sourceFriendFamily: 'Друг или семья',
    sourceCurrentStudent: 'Текущий ученик',
    source2GIS: '2GIS / Яндекс Карты',
    sourceFlyerBanner: 'Листовка или баннер',
    sourceSchoolEvent: 'Мероприятие школы',
    sourceWalkIn: 'Проходил мимо',
    sourceOther: 'Другое',
    reasonPrice: 'Цена',
    reasonSchedule: 'Расписание',
    reasonDistance: 'Расстояние',
    reasonWentToCompetitor: 'Ушёл к конкуренту',
    reasonTeacher: 'Преподаватель',
    reasonResults: 'Результаты',
    reasonMovedAway: 'Переехал',
    reasonNoReply: 'Не отвечает',
    reasonOther: 'Другое',
  },
};

export default ru;
